import { Injectable } from '@angular/core';
import { BaseDAO } from './baseDAO';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs/Rx';
import { HttpHeaders } from '@angular/common/http';
import { CharterNote } from 'anchor-shared/lib/model/entity/charterNote';

@Injectable()
export class CharterNoteDAO extends BaseDAO<string> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.CHARTER_NOTE);
  }

  public getNotes(charterId: number): Observable<CharterNote[]> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/' + charterId;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<CharterNote[]>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  public saveNote(
    charterId: number,
    note: string,
    vesselId?,
  ): Observable<CharterNote> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/' + charterId;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<CharterNote>(
      url,
      method,
      null,
      {
        note: note,
        vesselId,
      },
      headers,
    );
  }

  public saveBoatOwnerNote(
    charterId: number,
    publicId: string,
    note: string,
  ): Observable<CharterNote> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/' +
      charterId +
      '/' +
      publicId;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<CharterNote>(
      url,
      method,
      null,
      {
        note: note,
      },
      headers,
    );
  }

  public updateNote(noteId: number, note: string): Observable<CharterNote> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/update/' +
      noteId;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<CharterNote>(
      url,
      method,
      null,
      {
        note: note,
      },
      headers,
    );
  }
}
